<template>
  <div class="om-dropdown">
    <div class="om-dropdown__label" @click="reveal = !reveal" :class="{'is-open': reveal}">
      {{ choosedLabel ? choosedLabel : defaultLabel }}
    </div>
    <div v-if="reveal" class="om-dropdown__clickout" @click="reveal = !reveal"></div>
    <transition name="slide-down">
      <ul v-if="reveal" class="om-dropdown__list">
        <li v-for="item in items" @click.prevent="changeAction( item.value, typeof item.name !== 'undefined' ? item.name : item.value )" class="om-dropdown__item" :class="{'active': choosedValue === item.value}">
          <span v-if="typeof item.name !== 'undefined'" class="a">{{ item.name }}</span>
          <span v-else-if="typeof item.value !== 'undefined'" class="b">{{ item.value }}</span>
        </li>
      </ul>
    </transition>
  </div>
</template>
<script>
  export default {
    name: 'dropdown',
    data () {
      return {
        choosedValue: null,
        choosedLabel: null,
        reveal: false
      }
    },
    props: {
      //       asd
      items: Array,
      defaultValue: {
        'default': '--'
      },
      defaultLabel: {
        'default': '--'
      }
    },
    mounted () {
      if (this.defaultValue === '--') {
        this.defaultValue = this.$tr('--', 'dropdown')
      }
      if (this.items && typeof this.items[0] !== 'undefined') {
        this.choosedValue = typeof this.items[0].name !== 'undefined' ? this.items[0].name : (typeof this.items[0].value !== 'undefined' ? this.items[0].value : this.items[0])
      }
    },
    methods: {
      changeAction (val, lab) {
        console.log()
        this.reveal = false
        this.choosedLabel = lab
        this.choosedValue = val
        this.$emit('change', val)
      }
    }
  }
</script>

<style lang="scss" src="../../../assets/scss/reusable/dropdown.scss"></style>


// WEBPACK FOOTER //
// Dropdown.vue?3f588622